import {React, useEffect, useState} from 'react';
import { Amplify } from 'aws-amplify';
import config from './amplifyconfiguration.json';
import { signIn, signOut, getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';
import { Navigation } from './commons/navigation.tsx';
import ToolsContent from './commons/tools-content-general.tsx';
import { Notifications } from './commons/notifications.tsx';
import {
  AppLayout,
  BreadcrumbGroup,
  Container,
  Box,
  ContentLayout,
  Flashbar,
  Header,
  HelpPanel,
  Link,
  SideNavigation,
  SplitPanel,
  SpaceBetween,
} from '@cloudscape-design/components';
import { I18nProvider } from '@cloudscape-design/components/i18n';
import messages from '@cloudscape-design/components/i18n/messages/all.en';
import Grid from "@cloudscape-design/components/grid";
import { initialize } from '@iot-app-kit/source-iotsitewise';
import {fromCognitoIdentityPool} from "@aws-sdk/credential-providers";
import { LineChart, StatusTimeline, WebglContext } from "@iot-app-kit/react-components";
import "@iot-app-kit/components/styles.css";
const LOCALE = 'en';
const { defineCustomElements } = require("@iot-app-kit/components/loader");
defineCustomElements();
Amplify.configure(config);
isLoggedIn();



async function isLoggedIn() {
  try {
    const { username, userId, signInDetails } = await getCurrentUser();
    return username;
  } catch (error) {
    console.log("Not signed in");
    signIn({ username: "guest", password: 'guestguest' });
    console.log("signed in now");
  }
  
}
async function currentSessionOutside(){

  try {
    const {
        tokens,
        credentials,
        identityId,
        userSub
    } = await fetchAuthSession();

    const {
        accessKeyId,
        sessionToken,
        secretAccessKey,
        expiration
    } = credentials;

    const authenticated = true;
    credentials.expiration = undefined;
    return(credentials);
  } catch(e) {
    if (e.name === 'UserUnAuthenticatedException') {
      const authenticated = false;
      console.log("signin in");
      const { isSignedIn, nextStep } = await signIn({ username: "guest", password: 'guestguest' });

    }
  }
    
    
}
function SiteWise(credentials){

  if(credentials.credentials == null){
    return(null);
    }
  else {
    // console.log("logging output creds:");
    let newCreds = currentSessionOutside();
    // console.log(newCreds);
    // console.log("attempting IoT, logging credentials");
    // console.log(credentials);
    const { query } = initialize({
      awsCredentials: newCreds,
      awsRegion: "eu-central-1",
    });
    return(
      <Container>

                <div className="StatsView">
                
        <header className="StatsView-header">
          <h1>Stats - powered by the <a target="_blank" rel="noopener noreferrer" href="https://awslabs.github.io/iot-app-kit">IoT App Kit</a></h1>
          <br />
        </header>
        <SpaceBetween size="l">
        <Grid
        gridDefinition={[
          { colspan: { default: 12, xxs: 6 } },
          { colspan: { default: 12, xxs: 6 } },
          { colspan: { default: 12, xxs: 6 } },
          { colspan: { default: 12, xxs: 6 } }
        ]}
      >
        <div>
        <Container
          style={{height:"2000px"}}
          header={
            <Header variant="h2">Humidity (%)</Header>
          }
          
        >
          <div style={{height: 250}}>
          <LineChart
                queries={[
                  query.timeSeriesData(
                    {
                      assets: [
                      {
                        // Replace sitewse-asset-id with the ID of your AWS IoT SiteWise asset.
                        assetId: 'ce614f64-602a-4582-bd03-9131b3ae7fb7',
                        // Replace property-id with the ID of your AWS IoT SiteWise asset property.
                        properties: [{ propertyId: 'bfb5e67a-83f6-444c-b12b-a5fed04dff27', refId: 'munich-styles' } ],
                      },
                      {
                        // Replace sitewse-asset-id with the ID of your AWS IoT SiteWise asset.
                        assetId: '8b174f24-d425-4ebc-aded-c3be981194c3',
                        // Replace property-id with the ID of your AWS IoT SiteWise asset property.
                        properties: [{ propertyId: 'bfb5e67a-83f6-444c-b12b-a5fed04dff27', refId: 'madrid-styles' }],
                      },
                      {
                        // Replace sitewse-asset-id with the ID of your AWS IoT SiteWise asset.
                        assetId: 'b5a98fd8-070d-4707-b12b-654bb5a64a0a',
                        // Replace property-id with the ID of your AWS IoT SiteWise asset property.
                        properties: [{ propertyId: 'bfb5e67a-83f6-444c-b12b-a5fed04dff27', refId: 'barcelona-styles' }],
                      },
                      {
                        // Replace sitewse-asset-id with the ID of your AWS IoT SiteWise asset.
                        assetId: '0962a973-4faa-4eb8-838f-63f9351dfbae',
                        // Replace property-id with the ID of your AWS IoT SiteWise asset property.
                        properties: [{ propertyId: 'bfb5e67a-83f6-444c-b12b-a5fed04dff27', refId: 'las-vegas-styles' }],
                      }
                    ]
                    }
                  )
                ]}
                axis={{ yAxisLabel: '%' }}
                viewport={{"yMin": "20", "yMax": "80"}}
                styles={{ 'munich-styles': { color: 'orange', name: 'Munich', unit: '%' }, 'madrid-styles': { color: 'red', name: 'Madrid', unit: '%' }, 'barcelona-styles': { color: 'blue', name: 'Barcelona', unit: '%' }, 'las-vegas-styles': { color: 'green', name: 'Berlin', unit: '%' }  }}
              />
              <WebglContext />
              </div>
        </Container>
          </div>
        <div>
        <Container
          header={
            <Header variant="h2">
              Temperature (°Celsius)
            </Header>
          }
        >
          <div style={{height: 250}}>
          <LineChart
                queries={[
                  query.timeSeriesData(
                    {
                      assets: [
                      {
                        // Replace sitewse-asset-id with the ID of your AWS IoT SiteWise asset.
                        assetId: 'ce614f64-602a-4582-bd03-9131b3ae7fb7',
                        // Replace property-id with the ID of your AWS IoT SiteWise asset property.
                        properties: [{ propertyId: '68fd7f9d-d10a-408a-b45e-39cf8a119295', refId: 'munich-styles' } ],
                      },
                      {
                        // Replace sitewse-asset-id with the ID of your AWS IoT SiteWise asset.
                        assetId: '8b174f24-d425-4ebc-aded-c3be981194c3',
                        // Replace property-id with the ID of your AWS IoT SiteWise asset property.
                        properties: [{ propertyId: '68fd7f9d-d10a-408a-b45e-39cf8a119295', refId: 'madrid-styles' }],
                      },
                      {
                        // Replace sitewse-asset-id with the ID of your AWS IoT SiteWise asset.
                        assetId: 'b5a98fd8-070d-4707-b12b-654bb5a64a0a',
                        // Replace property-id with the ID of your AWS IoT SiteWise asset property.
                        properties: [{ propertyId: '68fd7f9d-d10a-408a-b45e-39cf8a119295', refId: 'barcelona-styles' }],
                      },
                      {
                        // Replace sitewse-asset-id with the ID of your AWS IoT SiteWise asset.
                        assetId: '0962a973-4faa-4eb8-838f-63f9351dfbae',
                        // Replace property-id with the ID of your AWS IoT SiteWise asset property.
                        properties: [{ propertyId: '68fd7f9d-d10a-408a-b45e-39cf8a119295', refId: 'las-vegas-styles' }],
                      }
                    ]
                    }
                  )
                ]}
                axis={{ yAxisLabel: '°C' }}
                styles={{ 'munich-styles': { color: 'orange', name: 'Munich', unit: '°C' }, 'madrid-styles': { color: 'red', name: 'Madrid', unit: '°C' }, 'barcelona-styles': { color: 'blue', name: 'Barcelona', unit: '°C' }, 'las-vegas-styles': { color: 'green', name: 'Berlin', unit: '°C' }  }}
              />
              </div>
        </Container>
          </div>
        <div>
        <Container
          header={
            <Header variant="h2">Moisture (%)</Header>
          }
        >
          <div style={{height: 250}}>
          <LineChart
                queries={[
                  query.timeSeriesData(
                    {
                      assets: [
                      {
                        // Replace sitewse-asset-id with the ID of your AWS IoT SiteWise asset.
                        assetId: 'ce614f64-602a-4582-bd03-9131b3ae7fb7',
                        // Replace property-id with the ID of your AWS IoT SiteWise asset property.
                        properties: [{ propertyId: '40705f41-04bb-40f6-801b-d5e4ecfc3e51', refId: 'munich-styles' } ],
                      },
                      {
                        // Replace sitewse-asset-id with the ID of your AWS IoT SiteWise asset.
                        assetId: '8b174f24-d425-4ebc-aded-c3be981194c3',
                        // Replace property-id with the ID of your AWS IoT SiteWise asset property.
                        properties: [{ propertyId: '3ef8e5ea-c8ac-4a4f-b2c2-9adda2195ffc', refId: 'madrid-styles' }],
                      },
                      {
                        // Replace sitewse-asset-id with the ID of your AWS IoT SiteWise asset.
                        assetId: 'b5a98fd8-070d-4707-b12b-654bb5a64a0a',
                        // Replace property-id with the ID of your AWS IoT SiteWise asset property.
                        properties: [{ propertyId: '40705f41-04bb-40f6-801b-d5e4ecfc3e51', refId: 'barcelona-styles' }],
                      },
                      {
                        // Replace sitewse-asset-id with the ID of your AWS IoT SiteWise asset.
                        assetId: '0962a973-4faa-4eb8-838f-63f9351dfbae',
                        
                        // Replace property-id with the ID of your AWS IoT SiteWise asset property.
                        properties: [{ propertyId: '40705f41-04bb-40f6-801b-d5e4ecfc3e51', refId: 'las-vegas-styles' }],
                      }
                    ]
                    }
                  )
                ]}
                axis={{ yAxisLabel: '%' }}
                
                styles={{ 'munich-styles': { color: 'orange', name: 'Munich', unit: '%' }, 'madrid-styles': { color: 'red', name: 'Madrid', unit: '%' }, 'barcelona-styles': { color: 'blue', name: 'Barcelona', unit: '%' }, 'las-vegas-styles': { color: 'green', name: 'Berlin', unit: '%' }  }}
              />
              </div>
        </Container>
          </div>
        <div>
          <Container
          header={<Header variant="h2">Pump</Header>}
        >
          <div style={{height: 250}}>
          <StatusTimeline
                queries={[
                  query.timeSeriesData(
                    {
                      assets: [
                      {
                        // Replace sitewse-asset-id with the ID of your AWS IoT SiteWise asset.
                        assetId: 'ce614f64-602a-4582-bd03-9131b3ae7fb7',
                        // Replace property-id with the ID of your AWS IoT SiteWise asset property.
                        properties: [{ propertyId: '03b92b06-52f3-4cea-bd61-8256de7d4f94', refId: 'munich-styles' } ],
                      },
                      {
                        // Replace sitewse-asset-id with the ID of your AWS IoT SiteWise asset.
                        assetId: '8b174f24-d425-4ebc-aded-c3be981194c3',
                        // Replace property-id with the ID of your AWS IoT SiteWise asset property.
                        properties: [{ propertyId: '03b92b06-52f3-4cea-bd61-8256de7d4f94', refId: 'madrid-styles' }],
                      },
                      {
                        // Replace sitewse-asset-id with the ID of your AWS IoT SiteWise asset.
                        assetId: 'b5a98fd8-070d-4707-b12b-654bb5a64a0a',
                        // Replace property-id with the ID of your AWS IoT SiteWise asset property.
                        properties: [{ propertyId: '03b92b06-52f3-4cea-bd61-8256de7d4f94', refId: 'barcelona-styles' }],
                      },
                      {
                        // Replace sitewse-asset-id with the ID of your AWS IoT SiteWise asset.
                        assetId: '0962a973-4faa-4eb8-838f-63f9351dfbae',
                        // Replace property-id with the ID of your AWS IoT SiteWise asset property.
                        properties: [{ propertyId: '03b92b06-52f3-4cea-bd61-8256de7d4f94', refId: 'las-vegas-styles' }],
                      }
                    ]
                    }
                  )
                ]}
                thresholds={[
                  {
                    "color": "blue",
                    "value": "ON",
                    "comparisonOperator": "EQ"
                  },
                  {
                    "color": "#a3a8a5",
                    "value": "OFF",
                    "comparisonOperator": "EQ"
                  }
                ]}
                viewport={{"duration": "6h"}}
                styles={{ 'munich-styles': { color: 'orange', name: 'Munich' }, 'madrid-styles': { color: 'red', name: 'Madrid' }, 'barcelona-styles': { color: 'blue', name: 'Barcelona' }, 'las-vegas-styles': { color: 'green', name: 'Berlin' }  }}
              />
              </div>
        </Container>
          </div>
      </Grid>
        
        
        
        
        </SpaceBetween>
        
      </div>
              </Container> 
    )
  }
}


export default function () {
 
  const [credentials, setCredentials] = useState(null);
  const [toolsOpen, setToolsOpen] = useState(false);
  const [navOpen, setNavOpen] = useState(false);

  useEffect(() => {
    
    async function currentSession() {
      try {
        const {
            tokens,
            credentials,
            identityId,
            userSub
        } = await fetchAuthSession();
    
        const {
            accessKeyId,
            sessionToken,
            secretAccessKey,
            expiration
        } = credentials;

        const authenticated = true;
        credentials.expiration = undefined;
        setCredentials(credentials);
        return(credentials);
      } catch(e) {
        if (e.name === 'UserUnAuthenticatedException') {
          const authenticated = false;
          console.log("signin in");
          const { isSignedIn, nextStep } = await signIn({ username: "guest", password: 'guestguest' });
    
        }
      }
    }

  
    currentSession().then((response) => {
      let currentcreds = response;
      setCredentials(response);
    })
    return () => {
      signOut();
      setCredentials(null);
  	};
  }, []); // Empty dependency array ensures this effect runs only once on mount


// const { query } = initialize({
//   awsCredentials: currentSession() ,
//   awsRegion: "eu-central-1",
// });

  return (
    <I18nProvider locale={LOCALE} messages={[messages]}>
      <AppLayout
        breadcrumbs={
          <BreadcrumbGroup
            items={[
              { text: 'Plantly', href: '#' },
              { text: 'Dashboard', href: '#' },
            ]}
          />
        }
        navOpen={navOpen}
          onNavChange={({ detail }) => setNavOpen(detail.open)}
          navigation={<Navigation activeHref="/dashboard" />}
          notifications={<Notifications />}
          toolsOpen={toolsOpen}
          onToolsChange={({ detail }) => setToolsOpen(detail.open)}
          tools={ToolsContent}
        content={
          <ContentLayout
            header={
              <Header variant="h1" info={<Link variant="info">Info</Link>}>
                Plantly Main Dashboard
              </Header>
            }
          >
          {/* {if ({credentials}) {
            <SiteWise credentials= {credentials} /> 
          }} */}
           <SiteWise credentials= {credentials} />
            
          </ContentLayout>
        }
        // splitPanel={<SplitPanel header="Split panel header">Split panel content</SplitPanel>}
      />
    </I18nProvider>
  );
}

